import {
  BaseFieldWidget,
  DslDefinition,
  FormM2MTableFieldWidget,
  ModelFieldType,
  SPI,
  ViewType
} from '@kunlun/dependencies';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: 'libra.inventory.LibraShopMatchWarehouseSetting',
    name: 'sendWarehousesProxy',
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany,
    widget: 'Table'
  })
)
export class AddSameTableDataNoFields extends FormM2MTableFieldWidget {
  public getDsl(): DslDefinition {
    // excludeItems里配一个不存在的字段就可以添加重复数据
    return { ...super.getDsl(), excludeItems: ['codeeeeeeex'] };
  }
}
